<template>
    <Modal
        v-model="modal"
        :title="obj.title"
        @on-ok="ok"
        @on-cancel="cancel">
        <div class="content">
            <b-label-frame label="属性名称" showStar>
                <Input autofocus v-model="obj.data.name" maxlength="6" placeholder="请输入"></Input>
            </b-label-frame>
            <b-label-frame label="验证规则" v-if="obj.data.type === '1'">
                <Input v-model="obj.data.matchRule" placeholder="请输入"></Input>
            </b-label-frame>
        </div>
    </Modal>
</template>
<script>
import BLabelFrame from '../../../components/baseLabelFrame.vue'
import utils from '../../../common/utils'
import api from '../../../common/api'

export default {
    name: 'UpdateAttrInfoDialog',
    props: {
        obj: {
            type: Object,
            required: true
        }
    },
    data() {
        return {
            modal: false
        }
    },
    components: {
        BLabelFrame
    },
    watch: {
        'obj.isShow': function () {
            this.modal = this.obj.isShow
        }
    },
    methods: {
        updateAttrInfo() {
            api.editUserAttr(this.obj.data).then((res) => {
                utils.resSucFactory(res, () => {
                    this.$emit('closeDialog', 'confirm', this.obj.data)
                }, () => {
                    this.$Message.error({
                        background: true,
                        content: 'api请求失败'
                    })
                })
            })
        },
        ok() {
            if (!this.obj.data.name || !new RegExp('[\u4E00-\u9FA5]+').test(this.obj.data.name)) {
                this.$Message.error({
                    background: true,
                    content: '请输入中文属性名称!'
                })
                return
            }
            this.updateAttrInfo()
        },
        cancel() {
            this.$emit('closeDialog')
        }
    }
}
</script>
